// Product cards (fresh-card): the hover image carousel (secondary-media) swallows
// clicks, so multi-image cards couldn't be opened by clicking the image. Delegated
// so it also covers cards loaded via AJAX filters / infinite scroll. Pagination
// dots are excluded - they keep switching slides.
(function () {
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.flickity-page-dots')) return;
    // Never hijack a real control. The action icons sit above the carousel only
    // because of z-index; if that CSS has not applied the carousel would swallow
    // their clicks and this handler would navigate to the product page instead of
    // adding to cart / opening quick view. Bail on any interactive element.
    if (e.target.closest('.ct__actions, .ct__iconbtn, button, a, input, label, select, [role="button"]')) return;
    var carousel = e.target.closest('.ct__carousel');
    if (!carousel) return;
    var media = carousel.closest('.ct__media');
    var link = media && media.querySelector('.ct__media-link');
    if (!link || !link.href) return;
    if (e.metaKey || e.ctrlKey) { window.open(link.href, '_blank'); return; }
    window.location.href = link.href;
  });
})();

// Filter drawer footer "Clear all" (snippets/facets-drawer.liquid).
// FacetForm (collection.js) re-renders only #FacetFiltersActive, #ProductGridContainer,
// #ProductCount, #SortByContainer and the [data-filter] accordion bodies - the drawer's
// sticky footer is in none of them. So the link's visibility was frozen at whatever the
// page was server-rendered with: it stayed after clearing, and never appeared after
// applying the first filter, until a reload. This mirrors <facet-count> / <results-count>:
// subscribe to facetUpdate and copy the `hidden` state out of the fetched section HTML.
if (window.customElements && !customElements.get('facet-clear-all')) {
  customElements.define(
    'facet-clear-all',
    class FacetClearAll extends HTMLElement {
      connectedCallback() {
        if (!window.theme || !theme.pubsub) return;
        this.facetUpdateUnsubscriber = theme.pubsub.subscribe(
          theme.pubsub.PUB_SUB_EVENTS.facetUpdate,
          this.onFacetUpdate.bind(this)
        );
      }

      disconnectedCallback() {
        if (this.facetUpdateUnsubscriber) this.facetUpdateUnsubscriber();
      }

      onFacetUpdate(event) {
        if (!event || !event.responseText) return;
        var parsedHTML = new DOMParser().parseFromString(event.responseText, 'text/html');
        var next = parsedHTML.querySelector('facet-clear-all');
        if (!next) return;
        // The href is the unfiltered collection/search URL, so it never changes -
        // only visibility has to follow the new filter count.
        this.hidden = next.hasAttribute('hidden');
      }
    }
  );
}
